import { render } from "./Main.vue?vue&type=template&id=3b00af2a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=3b00af2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b00af2a"

export default script